import {
    ContactContainer,
    Contacts,
    GoogleMaps,
} from "./contact.styles"
import phone from "../../assets/icons/phone.svg"
import location from "../../assets/icons/location-icon.svg"
import mail from "../../assets/icons/mail.svg"
import map from "../../assets/img/map.jpg"
import clock from "../../assets/icons/clock.svg"
import "./styles.scss"

const Contact = ({props}) => {
    return (
        <ContactContainer id="contacts">
            <h2>{props[1]}</h2>
            <Contacts>

                <ul>
                    <li className="contact-phones">
                        <img src={phone} alt=""/>
                        <a href="tel:+37379516890"><span>079 516 890</span></a>
                        {/*<a href="tel:+37379516890"><span> 079 516 890</span></a>,<a*/}
                        {/*href="tel:+37379516890"><span> 079 516 890</span></a>*/}
                    </li>
                    <li>
                        <img src={mail} alt=""/>
                        <a href="mailto:indadent.contact@gmail.com"><span>indadent.contact@gmail.com</span></a>
                    </li>
                    <li>
                        <img src={location} alt=""/>
                        <span><a
                            href="https://maps.app.goo.gl/deWR96FZYv6XFcWF7" target="_blank"
                            rel="noreferrer noopener">{props[2]}</a></span>
                    </li>
                    <li>
                        <img src={clock} alt=""/>
                        <span>{props[3]}</span>
                    </li>
                </ul>
            </Contacts>
            <a
                href="https://maps.app.goo.gl/deWR96FZYv6XFcWF7"
                target="_blank"
                rel="noreferrer noopener"
            >
                <GoogleMaps>
                    <img src={map} alt=""/>

                </GoogleMaps>
            </a>
            <div className="bank-details">
                <span className="bank-details_header">{props.requisites}</span>
                <div className="cols-wrapper">
                    <div className="left-col">
                    <span>"INDADENT" SRL,  MD-2001 Moldova mun.Chișinău, str. Nicolae Anestiade 6, of. 4
c/f 1023600051505
IBAN MD17AG000000022515715742
BC”Moldova-Agroindbank” SA Chișinău ag.2 fil.25</span>
                    </div>
                    <div className="right-col">
                    <span>c/b AGRNMD2X                    
Director: Ceaglei Aurica  
Email: indadent23@gmail.com
Tel.: 079876652</span>
                    </div>
                </div>
            </div>
            {/* <Attention>
        <img src={attention} alt="" />
        {props[3]}
      </Attention> */}

        </ContactContainer>
    )
}

export default Contact
